import { useFetch } from '@chipinside/fetcher'
import { Box } from '@mui/material'
import React from 'react'

import JobDetailContent from '#/components/Jobs/JobDetail/Content'
import JobDetailFooter from '#/components/Jobs/JobDetail/Footer'
import JobDetailHeader from '#/components/Jobs/JobDetail/Header'
import LinearIndeterminate from '#/components/Loader'
import { useFarmSlug } from '#/store/ducks/farm'
import { endpoint } from '#/store/services/endpoints'

export default function JobDetail({ job }) {
  const farmSlug = useFarmSlug()
  const slug = job.slug

  const controllers = {
    results: farmSlug
      ? endpoint.farm.job.results({ farm: farmSlug, slug })
      : endpoint.job.self({ job: slug }),
    header: farmSlug
      ? endpoint.farm.job.header({ farm: farmSlug, slug })
      : endpoint.job.header({ slug: slug }),
  }

  /*
   * Get Job results
   * if failed retry in 30 sec
   */
  const { data, isLoading } = useFetch({
    controller: controllers.results,
    params: { per_page: 9999 },
    options: { errorRetryInterval: 30 * 1000 },
  })

  /*
   * Get Job header
   * if failed retry in 30 sec
   */
  const { data: header, isLoading: isLoadingHeader } = useFetch({
    controller: controllers.header,
    options: { errorRetryInterval: 30 * 1000 },
  })

  return isLoading || isLoadingHeader ? (
    <LinearIndeterminate status="started" />
  ) : (
    <Box>
      <JobDetailHeader {...header} />
      <JobDetailContent result={data.data} />
      <JobDetailFooter {...header} jobSlug={slug} />
    </Box>
  )
}
